import { defaultTheme } from '@hn-ui/themes';
var DEFAULT_PIE_VALUES_BY_CATEGORY = [
    {
        id: '< 30%',
        color: defaultTheme.colors.green99,
    },
    {
        id: '30% – 50%',
        color: defaultTheme.colors.green95,
    },
    {
        id: '50% – 80%',
        color: defaultTheme.colors.green70,
    },
    {
        id: '80% – 100%',
        color: defaultTheme.colors.green40,
    },
    {
        id: '> 100%',
        color: defaultTheme.colors.green20,
    },
];
var DEFAULT_PIE_VALUES_BY_GRADE = [
    {
        id: -2,
        color: '#C5C7D4',
    },
    {
        id: -1,
        color: '#DA3D4D',
    },
    {
        id: 0,
        color: '#FD7B88',
    },
    {
        id: 1,
        color: '#9ED9FC',
    },
    {
        id: 2,
        color: '#42ABE9',
    },
    {
        id: 3,
        color: '#1A95DE',
    },
    {
        id: 4,
        color: '#1982BF',
    },
    {
        id: 5,
        color: '#126799',
    },
];
export { DEFAULT_PIE_VALUES_BY_CATEGORY, DEFAULT_PIE_VALUES_BY_GRADE };
